import {Button, Popover, Space, Tooltip} from 'antd';
import React, { useState } from 'react';
import {DeleteOutlined} from "@ant-design/icons";

//title, callback
export const DeleteAction: React.FC = () => {
    const [open, setOpen] = useState(false);

    const handleOpenChange = (newOpen: boolean) => {
        setOpen(newOpen);
    };

    return (
            <Popover
                content={
                    <React.Fragment>
                        <Space>
                            <Button danger type={`primary`}>Yes</Button>
                            <Button>No</Button>
                        </Space>
                    </React.Fragment>
                }
                title="Are you sure you want to delete this item?"
                trigger="click"
                open={open}
                onOpenChange={handleOpenChange}
            >
                <Tooltip title="delete">
                    <Button danger type="dashed" shape="circle" icon={<DeleteOutlined />} />
                </Tooltip>
            </Popover>
    );
};
